import "./style.scss";
import Form from "./Form";

function App() {
  return (
    <div className="Upload">
      <div className="grid">
        <div className="content">
          <p style={{ marginBottom: 0, fontWeight: "bold" }}>
            Ein letzter Schritt:
          </p>
          <h1>Fahrzeugschein-Upload</h1>
          <div className="text">
            <p>
              Damit bei der Meldung an die Versicherung alles glatt läuft, lade
              bitte deinen Fahrzeugschein über das angehängte Formular hoch.
            </p>
            <p>Erlaubt sind Bilder (JPEG, PNG) oder PDFs.</p>
            <p>Orientiere dich bitte an folgender Vorlage:</p>
            <div className="fz-grid">
              <div>
                <p>Vorderseite</p>
                <img
                  src={
                    "https://www.emover24.com/wp-content/uploads/2022/10/fz1.png"
                  }
                  alt="Vorne"
                />
              </div>
              <div>
                <p>Rückseite</p>
                <img
                  src={
                    "https://www.emover24.com/wp-content/uploads/2022/10/fz2.png"
                  }
                  alt="Hinten"
                />
              </div>
            </div>
          </div>
        </div>
        <Form />
      </div>
    </div>
  );
}

export default App;
